/**
 * @generated SignedSource<<679f5a2820f228aa03ce87bb661f85d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FullAdPreview_PerformanceSummarizedMetaAd$data = {
  readonly id: string;
  readonly preview: string;
  readonly " $fragmentType": "FullAdPreview_PerformanceSummarizedMetaAd";
};
export type FullAdPreview_PerformanceSummarizedMetaAd$key = {
  readonly " $data"?: FullAdPreview_PerformanceSummarizedMetaAd$data;
  readonly " $fragmentSpreads": FragmentRefs<"FullAdPreview_PerformanceSummarizedMetaAd">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "adPreviewFormat"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FullAdPreview_PerformanceSummarizedMetaAd",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "format",
          "variableName": "adPreviewFormat"
        }
      ],
      "kind": "ScalarField",
      "name": "preview",
      "storageKey": null
    }
  ],
  "type": "PerformanceSummarizedMetaAd",
  "abstractKey": null
};

(node as any).hash = "903d01b49e581fd1c2a26c779ffeae9d";

export default node;
